// ChooseLocation.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useApi from '../hooks/useApi';
import { endpoints } from '../utils/utils';
import MenuHeader from './MenuHeader';
import useLogout from '../hooks/useLogout';
import { useTranslation } from 'react-i18next';


const Profile = () => {

  const { t, i18n } = useTranslation('profile');
  const [user, setUser] = useState();
  const api = useApi()
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    /* let toolTip = document.getElementById("tooltip");

    window.addEventListener("mousemove", toolTipXY);

    function toolTipXY(e) {
        let x = e.clientX,
            y = e.clientY;
        toolTip.style.top = y + 20 + "px";
        toolTip.style.left = x + 20 + "px";
    } */

    const getUsers = async () => {
      try {
        const response = await api.get(endpoints.getProfil);

        console.log(response.data);
        isMounted && setUser(response.data);
      } catch (err) {
        console.error(err);
        navigate('/login', { state: { from: location }, replace: true });
      }
    }

    getUsers();


    return () => {
      isMounted = false;
      controller.abort();
    }
  }, [])

  const urlsFly = {
    cgu: i18n.language === 'fr' 
      ? 'https://flyspa.ch/conditions-generales-utilisation/' 
      : 'https://flyspa.ch/en/general-terms-of-use/',
    privacy: i18n.language === 'fr' 
      ? 'https://flyspa.ch/politique-de-confidentialite/' 
      : 'https://flyspa.ch/en/privacy-policy/'
  };

  
  return (
    <>
      <MenuHeader />

      <div className="container container-profile">
        <div className="name">{user?.user?.firstname} {user?.user?.lastname}</div>
        <div className="lieu">{user?.user?.primary_address?.city}</div>
        <div className="adress">
          <h3>Adresse</h3>
          <div className="rue">{user?.user?.primary_address?.street} {user?.user?.primary_address?.street_number}<br /> {user?.user?.primary_address?.zip_code} {user?.user?.primary_address?.city}<br /> {user?.user?.phone}</div>
          <a href="#" className="edit" onClick={(e) => { e.preventDefault(); navigate('/editadresse', { state: { prefill: true } }); }}>Edit</a>
        </div>
        <div className="list">
          <ul>
            <li>
              <a href="/editprofile">{t('profile:edit_my_profile')}</a>
            </li>
            <li>
              <a href="/commande">{t('profile:my_orders')}</a>
            </li>
            <li>
              <a href="/my-cards">{t('profile:payment_card')}</a>
            </li>
            <li>
              <a target='_blank' href={urlsFly.cgu}>{t('profile:terms_and_privacy')}</a>
            </li>
            <li className="logout">
              <a href="#" onClick={signOut}>{t('profile:logout')}</a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Profile;
